import { useTranslation } from "react-i18next";
import { Link, NavLink } from "react-router-dom";

import type { Theme } from "../theme/theme";
import { LanguageSwitcher } from "../localization/LanguageSwitcher";
import { useLocalizedPath } from "../localization/urls";
import "./Masthead.css";

export function Masthead({ theme = "light", onToggleTheme }: { theme?: Theme; onToggleTheme: () => void }) {
  const { t } = useTranslation();
  const path = useLocalizedPath();
  return (
    <header className="masthead">
      <div className="wrap masthead-inner">
        <Link className="wordmark" to={path("/")} aria-label={t("site.title")}>
          <span className="wordmark-mark"><img src="/icons/brand-mark.png" alt="" /></span>
          {/* Hidden below the masthead's one-row breakpoint, where the mark carries the
              identity alone. The link's own aria-label is the accessible name either way,
              so nothing is lost when the words go. */}
          <span className="wordmark-text">{t("site.title")}</span>
        </Link>
        <nav className="sitenav" aria-label={t("nav.primary")}>
          <NavLink to={path("/map")}>{t("nav.map")}</NavLink>
          <NavLink to={path("/catalog")}>{t("nav.catalogue")}</NavLink>
        </nav>
        <div className="masthead-controls">
          <LanguageSwitcher />
          <button type="button" className="theme-toggle" onClick={onToggleTheme} aria-label={theme === "dark" ? t("theme.toLight") : t("theme.toDark")}>
            <span aria-hidden="true">{theme === "dark" ? "☀" : "◐"}</span>
            <span>{theme === "dark" ? t("theme.light") : t("theme.dark")}</span>
          </button>
        </div>
      </div>
    </header>
  );
}
